import React from 'react';
import './AccordionContentRenderer.css';

const AccordionContentRenderer = ({ content }) => {
  // Split by newlines and process line by line
  const lines = content.split('\n').filter(line => line.trim());
  const result = [];
  let currentParagraph = [];
  
  lines.forEach((line) => {
    const trimmed = line.trim();
    
    if (trimmed.startsWith('•')) {
      // If we have accumulated paragraph text, add it first
      if (currentParagraph.length > 0) {
        const paragraphText = currentParagraph.join(' ').trim();
        if (paragraphText.length > 0) {
          if (paragraphText.includes(':')) {
            result.push({ type: 'title', text: paragraphText });
          } else {
            result.push({ type: 'paragraph', text: paragraphText });
          }
        }
        currentParagraph = [];
      }
      
      // Add list item
      if (result.length === 0 || result[result.length - 1].type !== 'list') {
        result.push({ type: 'list', items: [] });
      }
      result[result.length - 1].items.push(trimmed.replace(/^•\s*/, ''));
    } else if (trimmed.length > 0) {
      // Regular text line - accumulate for paragraph
      currentParagraph.push(trimmed);
    } else {
      // Empty line - if we have accumulated text, finalize it
      if (currentParagraph.length > 0) {
        const paragraphText = currentParagraph.join(' ').trim();
        if (paragraphText.length > 0) {
          if (paragraphText.includes(':')) {
            result.push({ type: 'title', text: paragraphText });
          } else {
            result.push({ type: 'paragraph', text: paragraphText });
          }
        }
        currentParagraph = [];
      }
    }
  });
  
  // Handle any remaining paragraph text
  if (currentParagraph.length > 0) {
    const paragraphText = currentParagraph.join(' ').trim();
    if (paragraphText.length > 0) {
      if (paragraphText.includes(':')) {
        result.push({ type: 'title', text: paragraphText });
      } else {
        result.push({ type: 'paragraph', text: paragraphText });
      }
    }
  }
  
  return (
    <>
      {result.map((item, index) => {
        if (item.type === 'list') {
          return (
            <ul key={index} className="accordion-content-list">
              {item.items.map((listItem, itemIndex) => (
                <li key={itemIndex} className="accordion-content-list-item">{listItem}</li>
              ))}
            </ul>
          );
        } else if (item.type === 'title') {
          return (
            <h4 key={index} className="accordion-content-section-title">{item.text}</h4>
          );
        } else {
          return (
            <p key={index} className="accordion-content-paragraph">{item.text}</p>
          );
        }
      })}
    </>
  );
};

export default AccordionContentRenderer;

